<template>
  <div class="tool-bar">
    <button @click="() => changeMenu('homeView')" :class="{active: active == 'homeView'}">
      <img v-if="active == 'homeView'" src="./icons/btn_home_highlighted@2x.png"/>
      <img v-else src="./icons/btn_home_normal@2x.png"/>
      首页
    </button>
    <button @click="() => changeMenu('bookshelf')" :class="{active: active == 'bookshelf'}">
      <img v-if="active == 'bookshelf'" src="./icons/btn_bookshelf_highlighted.png"/>
      <img v-else src="./icons/btc_bookshelf_normal.png"/>
      已购买
    </button>
    <button @click="() => changeMenu('userspace')" :class="{active: active == 'userspace'}">
      <img v-if="active == 'userspace'" src="./icons/btn_personalcenter_highlighted@2x.png"/>
      <img v-else src="./icons/btn_personalcenter_normal@2x.png"/>
      我的
    </button>
  </div>
</template>

<script>
export default {
  name: 'MobileMenu',
  data() {
    return {
      active: 'homeView'
    }
  },
  mounted() {
    this.active = this.$route.name
  },
  methods: {
    changeMenu(name) {
      if(this.active == name) {
        return
      }
      this.active = name
      this.$router.push({name})
    },
  }
}
</script>

<style lang="less" scoped>
.tool-bar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding-bottom: env(safe-area-inset-bottom); /* iOS safe area */
  border-top: 1px solid #f0f0f0;
  
  button {
    border: 0;
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #999999;
    font-size: 11px;
    font-weight: 500;
    flex: 1;
    padding: 6px 0;
    transition: all 0.3s ease;
    
    img {
      height: 24px;
      margin-bottom: 4px;
      transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
    
    &:active img {
      transform: scale(0.85);
    }
  }
  
  .active {
    color: #0F5EBF;
    font-weight: 600;
    
    img {
      transform: translateY(-2px);
    }
  }
}
</style>
